import { hasActiveObservations as t } from "../algorithms/hasActiveObservations.js";
import { hasSkippedObservations as e } from "../algorithms/hasSkippedObservations.js";
import { deliverResizeLoopError as i } from "../algorithms/deliverResizeLoopError.js";
import { broadcastActiveObservations as s } from "../algorithms/broadcastActiveObservations.js";
import { gatherActiveObservationsAtDepth as o } from "../algorithms/gatherActiveObservationsAtDepth.js";
var n = function() {
  var r = 0;
  for (o(r); t(); )
    r = s(), o(r);
  return e() && i(), r > 0;
};
export {
  n as process
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/process.js
// module id = 1314
// module chunks = 41